"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ENDPOINTS = {
    IIG_SESSION: '/VGApp/iip/advisor/rest/fas-session',
    BASE_HOST_SAT_INTERNAL: 'https://satiami.vanguard.com',
    BASE_HOST_PROD_INTERNAL: 'https://iami.vanguard.com',
    BASE_HOST_SAT: 'https://satinstitutional.vanguard.com',
    BASE_HOST_PROD: 'https://institutional.vanguard.com',
    LOGGED_ON_STATUS_IE: '/VGApp/iip/institutional/isLoggedOnIE',
    LOGGED_ON_STATUS: '/VGApp/iip/institutional/isLoggedOn',
    USER_DETAIL_SERVICE: '/wtl-wtl-request/requestInfo/getUserDetail',
    WEB_SERVICE_SAT: 'https://satinstitutional.vanguard.com',
    WEB_SERVICE_PROD: 'https://institutional.vanguard.com',
    WEB_SERVICE_SAT_INTERNAL: 'https://satiami.vanguard.com',
    WEB_SERVICE_PROD_INTERNAL: 'https://iami.vanguard.com'
};
exports.default = ENDPOINTS;
